(function() {
    'use strict';
    angular.module('Services').factory('WarningModalFactory', WarningModalFactory);

    function WarningModalFactory($uibModal) {
        return function (prop, scope) {
            let modalProperties = {
                animation: false,
                windowClass: 'confirmation-modal fade',
                ariaDescribedBy: 'modal-body',
                templateUrl: '/templates/elements/warning-modal.html',
                controller: function($uibModalInstance, $scope) {
                    $scope.action = function(cond) {
                        $uibModalInstance.close(cond);
                    }
                    if(scope) {
                        angular.extend($scope, scope);
                    }
                },
                size: 'md',
                backdrop: 'static'
            };

            angular.extend(modalProperties, prop);

            function getInstance() {
                return $uibModal.open(modalProperties);
            }

            this.getInstance = getInstance;
        }
    }
})()


// WEBPACK FOOTER //
// ./js/services/UX/WarningModalFactory.js